exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mobileDropdownSelect__value___374lK {\n  background-color: #f2f2f2;\n  width: 100%;\n  border-radius: 8px; }\n\n.mobileDropdownSelect__valueDisabled___2nUNA {\n  width: 100%; }\n  .mobileDropdownSelect__valueDisabled___2nUNA div div div {\n    color: #ccc !important; }\n", ""]);

// exports
exports.locals = {
	"value": "mobileDropdownSelect__value___374lK",
	"valueDisabled": "mobileDropdownSelect__valueDisabled___2nUNA"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/RegistrationSelect/MobileRegistrationSelect/mobileDropdownSelect.scss
// module id = 1681
// module chunks = 6